import { gql } from '@apollo/client'

const GET_MEMBER_MERCHANT_BY_ID = gql`
  query getMerchant($merchantId: uuid!) {
    merchants_by_pk(id: $merchantId) {
      id
      name
      description
      slug
      setting
      vehicles
      pre_order_vehicles
      transaction_plan_id
      app_setting {
        id
        enabled
        google_play_url
        apple_store_url
      }
      integration_settings
      registered_company_name
      subscription
      has_onboarded
      dispatch_selfserve_enabled
      is_seo_enabled
      loyalty_scan_method
      stripe_settings {
        stripe_user_id
      }
      current_plan
      price_matrices(where: { archived_at: { _is_null: true } }) {
        id
        name
        data
        global
        stores {
          slug
        }
      }
    }
  }
`

const GET_MERCHANT_BY_ID = gql`
  query getMerchant($merchantId: uuid!) {
    merchants_by_pk(id: $merchantId) {
      id
      name
      description
      add_to_wallet_enabled
      slug
      setting
      vehicles
      pre_order_vehicles
      trust_pilot_email
      cro_registered_number
      transaction_plan_id
      app_setting {
        id
        enabled
        google_play_url
        apple_store_url
      }
      integration_settings
      registered_company_name
      subscription
      has_onboarded
      dispatch_selfserve_enabled
      is_seo_enabled
      loyalty_scan_method
      stripe_settings {
        stripe_user_id
      }
      address {
        merchant_id
        contact_num
        line_1
        line_2
        city
        country
        zip
        geom
      }
      current_plan
      zero_order_rate_id
      price_matrices(where: { archived_at: { _is_null: true } }) {
        id
        name
        data
        global
        stores {
          slug
        }
      }
    }
  }
`

const QUERY_MERCHANT_LOCATIONS = gql`
  query queryMerchantLocations($slug: String!) {
    merchants(where: { slug: { _eq: $slug } }) {
      stores {
        address {
          id
          geom
          line_1
          line_2
          city
          zip
        }
        email
        name
        slug
        is_open
        inserted_at
        archived_at
        id
        settings
        schedules
        pre_order_settings {
          pickup_enabled
          delivery_enabled
        }
        store_order_type_settings {
          order_type
          fulfillment_type
          auto_accept
        }
      }
    }
  }
`

const GET_STORES_BY_ID = gql`
  query getStores($storeIds: [uuid!]) {
    stores(where: { id: { _in: $storeIds } }) {
      id
      name
    }
  }
`

const GET_MERCHANT_CATEGORIES = gql`
  query getMerchantCategories($merchantId: uuid!) {
    categories(
      where: { merchant_id: { _eq: $merchantId } }
      order_by: { name: asc }
    ) {
      id
      name
      slug
      description
      archived_at
      products_categories(
        where: { product: { archived_at: { _is_null: true } } }
      ) {
        id
      }
      category_special_availabilities {
        special_availability {
          id
          end_time
          end_datetime
          rrule
          order_type
          store_special_availabilities {
            store {
              id
              slug
            }
          }
        }
      }
    }
  }
`

const GET_MERCHANT_INTEGRATIONS = gql`
  query getMerchantPartners($merchantId: uuid!) {
    partners_merchants(where: { merchant_id: { _eq: $merchantId } }) {
      partner {
        name
      }
    }
  }
`

const QUERY_STRIPE_CONNECT_URL = gql`
  query stripeConnect($redirectUri: String, $merchantId: String) {
    stripeConnectUrl(redirectUri: $redirectUri, merchantId: $merchantId) {
      url
      hasConnected
      type
      login_link
      hasOnboarded
    }
  }
`

export {
  GET_MEMBER_MERCHANT_BY_ID,
  GET_MERCHANT_BY_ID,
  GET_STORES_BY_ID,
  QUERY_MERCHANT_LOCATIONS,
  GET_MERCHANT_CATEGORIES,
  GET_MERCHANT_INTEGRATIONS,
  QUERY_STRIPE_CONNECT_URL
}
